import styled from 'styled-components';

export const Container = styled.article`
  display: grid;
  grid-template-columns: 290px 1fr;
  position: relative;
  color: white;

  span {
    font-weight: 100;
  }
`;

export const StartupData = styled.div`
  display: grid;
  gap: 5px;
  padding: 35px;
  background: ${props => props.theme.darkGray};
  border-radius: 5px 0 0 5px;
  
  div {
    margin: 10px 0;
  }

  p {
    margin: 0;
  }

  span {
    font-size: 14px
  }

  @media (max-width: 425px) {
    padding: 20px;
    
    figure {
      width: 50%;
      display: grid;
      justify-self: center;
    }

    div {
      margin: 0;
    }

    p {
      font-size: 14px;
    }

    span {
      font-size: 12px;
    }
  }
`;

export const Content = styled.div`
  display: grid;
  gap: 25px;
  padding: 5%;
  position: relative;
  background-repeat: no-repeat;
  background-size: cover;
  border-radius: 0 5px 5px 0;

  p, span {
    margin: 0;
    z-index: 2;
    text-shadow: 0px 5px 5px #121212;
  }
  
  p {
    font-size: 18px;
  }

  div {
    display: grid;
    gap: 5px;
  }

  @media (max-width: 425px) {
    p {
      font-size: 14px;
    }

    span {
      font-size: 12px;
    }
  }
`;

export const BackgroundContentImage = styled.div`
  background-image: url('/images/startups/background.png');
  background-repeat: no-repeat;
  z-index: 1;
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
`;

export const BackgroundContentColor = styled.div`
  background: rgba(0,0,0,0.7);
  border-radius: 0 5px 5px 0;
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
`;
